<template>
  <div class="echarts" :style="'height:'+height+';'+'width:'+width"></div>
</template>

<style scoped>
.echarts {
  height: 400px;
  width: 600px;
}
</style>

<script>
import echarts from "echarts/lib/echarts";
import { addListener, removeListener } from "resize-detector";

function debounce(fn, timeout) {
  let now = null;
  return function () {
    const context = this;
    if (!now) {
      fn.apply(context, arguments);
      now = Date.now();
    } else {
      const t = Date.now() - now;
      if (t >= timeout) {
        fn.apply(context, arguments);
        now = Date.now();
      }
    }
  };
}

export default {
  name: "ECarts",
  props: {
    options: {
      type: Object,
    },
    initOptions: Object,
    autoResize: Boolean,
    height: {
      type: String,
      default: "400px",
    },
    width: {
      type: String,
      default: "600px",
    },
  },
  watch: {
    options: {
      handler(val) {
        console.log("options update", val);
        this.refresh();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    delegateMethod(name, ...args) {
      if (!this.chart) {
        this.init();
      }
      return this.chart[name](...args);
    },
    resize(options) {
      this.delegateMethod("resize", options);
    },
    init(options) {
      if (this.chart) {
        return;
      }

      const chart = echarts.init(this.$el, null, this.initOptions);

      chart.setOption(options || this.options || {}, true);

      if (this.autoResize) {
        console.log("set resize");
        this.__resizeHandler = debounce(() => {
          this.resize();
        }, 200);
        addListener(this.$el, this.__resizeHandler);
      }

      this.chart = chart;
    },
    dispose() {
      this.delegateMethod("dispose");
    },
    destroy() {
      if (this.autoResize) {
        removeListener(this.$el, this.__resizeHandler);
      }
      this.dispose();
      this.chart = null;
    },
    refresh() {
      if (this.chart) {
        this.destroy();
        console.log("dispose done, do init");
        this.init();
      }
    },
  },
  mounted() {
    if (this.options) {
      this.init();
    }
  },
  activated() {
    if (this.autoResize) {
      this.chart && this.chart.resize();
    }
  },
  destroyed() {
    if (this.chart) {
      this.destroy();
    }
  },
};
</script>
